import { useState } from "react";

const KEY = "fms.chartPref";
const baca = () => { try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { return {}; } };

// Ingat tipe grafik (batang | pie | orang) per grafik di localStorage
export default function useChartPref(id, fallback = "batang") {
  const [tipe, setTipe] = useState(() => baca()[id] || fallback);
  const simpan = (v) => { setTipe(v); try { localStorage.setItem(KEY, JSON.stringify({ ...baca(), [id]: v })); } catch { /* abaikan */ } };
  return [tipe, simpan];
}
